// extracted by mini-css-extract-plugin
export default {"fieldSpinner":"xf0mH"};